import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { IssueWebService } from '../../services/issue-web.service';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { SiteService } from '../../services';

@Injectable()
export class IssueGuard implements CanActivate {

    constructor(
        private router: Router,
        private siteService: SiteService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
    ) { }
    canActivate(routeSnap: ActivatedRouteSnapshot) {
        var id = routeSnap.params.id;

        if (id) {
            return this.siteService.getByGuid(id).pipe(map(response => {
                console.log(response);

                if (this.siteService.DISABLED_ID.includes(response.Data.Id)) {
                    this.router.navigateByUrl(`/not-found`)
                    return false
                }

                return true;
            }), catchError(err => {
                console.log(err);
                this.router.navigateByUrl(`/not-found`)
                return of(false);
            }));
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/issue.guard.ts